/*
 * @Author: zhouwei
 * @Date: 2019-11-18 15:22:09
 * @Last Modified by: zhouwei
 * @Last Modified time: 2020-06-17 14:55:49
 * @Desc: 表单数据列表
*/
<template>
  <div class="form-data">
    <div class="header">
      <div class="header-left">
        <div class="search-list">
          <!-- filterable -->
          <mk-cascader
            v-model="tag"
            class="search-list-item"
            :options="options"
            collapse-tags
            size="small"
            :props="props"
            placeholder="选择标签(多选)"
            width="320"
            clearable
          ></mk-cascader>
          <mk-select
            v-model="state"
            width="120"
            class="search-list-item"
          >
            <mk-option
              v-for="(item,index) in stateList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></mk-option>
          </mk-select>
          <mk-input
            v-model="titleVal"
            width="240"
            class="search-list-item search-list-item-title"
            placeholder="请输入标题"
            clearable
            maxlength="20"
            @keyup.enter.native="search"
          >
            <div
              slot="suffix"
              class="el-input__icon"
            >
              <i
                class="el-icon-search"
                @click="search"
              />
            </div>
          </mk-input>
        </div>
        <div class="btn-group">
          <mk-button-biz
            icon="el-icon-search"
            type="primary"
            @click="search"
          >
            搜索
          </mk-button-biz>
          <mk-button-biz @click="reset">
            重置
          </mk-button-biz>
        </div>
      </div>
      <div class="show-tips">
        <mk-popover
          class="h-title"
          placement="left"
          trigger="hover"
          reference=""
        >
          <div
            class="h-t-popover"
            style="line-height:24px;"
          >
            <span style="font-weight: 500;">累计浏览量（PV）：</span>
            该表单的 累计⻚⾯浏览量，⽤户每次刷新即被计算⼀次。<br />
            <span style="font-weight: 500;">累计浏览人数（UV）：</span>
            该表单的累计页面浏览人数。每⽇（00:00-24:00）内相同的<br />
            访客只被计算⼀次。<br />
            <span style="font-weight: 500;">提交次数：</span>
            提交该表单内容的次数。
          </div>
          <template slot="reference">
            <div class="tips">
              <mk-iconfont
                class="icon"
                icon-class="question-mark"
                style="color: #888;"
              ></mk-iconfont>
              <span>该页面展示企业全部表单及获取的所有数据</span>
            </div>
          </template>
        </mk-popover>
      </div>
    </div>
    <div class="table">
      <!-- height="calc(100vh - 230px)" -->
      <mk-table
        v-if="tableMaxHeight"
        :max-height="tableMaxHeight"
        :data="formData"
      >
        <mk-table-column
          prop="title"
          label="标题"
          min-width="200"
          show-overflow-tooltip
        ></mk-table-column>
        <mk-table-column
          label="发布状态"
          width="100"
        >
          <template slot-scope="scope">
            <span
              v-if="scope.row.status === 1"
              style="color:#3fc667;"
            >已发布</span>
            <span
              v-else
              style="color:#8c8c8c;"
            >已下线</span>
          </template>
        </mk-table-column>
        <mk-table-column
          label="标签"
          width="320"
        >
          <template v-slot="scope">
            <tag-list-show
              :tag-list="scope.row.showTags"
              :limit="3"
            />
          </template>
        </mk-table-column>
        <mk-table-column
          prop="pv"
          label="累计浏览量（PV）"
          width="160"
        ></mk-table-column>
        <mk-table-column
          prop="uv"
          label="累计浏览人数（UV）"
          width="160"
        ></mk-table-column>
        <mk-table-column
          prop="submitNum"
          label="提交次数"
          width="120"
        ></mk-table-column>
        <mk-table-column
          label="操作"
          width="60"
          fixed="right"
        >
          <template slot-scope="scope">
            <mk-button-biz
              type="text"
              size="small"
              @click="handleClick(scope.row)"
            >
              详情
            </mk-button-biz>
          </template>
        </mk-table-column>
      </mk-table>
    </div>
    <div class="pagination">
      <mk-pagination
        :current-page.sync="page"
        :page-size="10"
        layout="total, prev, pager, next, jumper"
        :total="total"
        @current-change="handleCurrentChange"
      >
      </mk-pagination>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import { BIZAPIS } from '@api'
import tagListShow from '@components/tag-list-show'
import routeConfig from '@/router/home/form-data.js'
export default {
  components: {
    tagListShow
  },
  props: {
    showAll: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tableMaxHeight: 0,
      tag: [], // 多选标签集合
      state: 'all', // 发布状态
      options: [], // 标签内容
      titleVal: '', // 搜索标题
      props: {
        // 重定义多选属性名
        label: 'name',
        value: 'id',
        multiple: true
      },
      stateList: [
        // value同后台接口对标
        {
          label: '全部状态',
          value: 'all'
        },
        {
          label: '已发布',
          value: 1
        },
        {
          label: '已下线',
          value: 2
        }
      ],
      formData: [],
      page: 1,
      total: 0
    }
  },
  created () {
    const user = JSON.parse(window.localStorage.getItem('user'))
    if (user.roleLimits.pcDataLimits.m1_formData === 'all') {
      this.setFormText('')
    } else if (user.roleLimits.pcDataLimits.m1_formData === 'dept') {
      this.getDepartment(user.departmentId)
    } else {
      if (user.name) {
        this.setFormText(' —— ' + user.name)
      }
    }
    this.getTags()
    this.getFormDataList()
  },
  mounted () {
    this.$nextTick(() => {
      this.util.handleTableMaxHeight('.table', this)
    })
  },
  beforeDestroy () {
    this.setFormText('')
  },
  methods: {
    ...mapMutations('system', {
      setFormText: 'SET_FORMTEXT'
    }),
    async getDepartment (id) {
      // 获取部门
      const res = await BIZAPIS.UserApi.timingPlanDepartmentAllGet()
      if (res.success) {
        let data = res.data
        data.push({
          _id: 'NA',
          name: '无部门'
        })
        this.getDeptName(data, id)
      }
    },
    getDeptName (arr, id) {
      if (arr instanceof Array) {
        arr.forEach(item => {
          if (item._id === id) {
            if (item.name !== '') {
              this.setFormText(' —— ' + item.name)
            }
          }
          if (item.children && item.children instanceof Array) {
            this.getDeptName(item.children, id)
          }
        })
      }
    },
    async getFormDataList () {
      let tag = this.tag
      let metas = {
        page: this.page,
        status: this.state,
        title: this.titleVal
        // tags: tag
      }
      if (this.state === 'all') {
        delete metas['status']
      }
      if (this.tag.length === 0) {
        delete metas['tags']
      } else {
        metas.tags = this.handleArray(this.tag)
      }
      const res = await BIZAPIS.FormApi.materialFormHasDataPost(metas)
      if (res.success) {
        this.formData = res.data.data
        this.total = res.data.total
      }
    },
    async getTags () {
      // 获取可用标签
      const res = await BIZAPIS.TagApi.tagEnableGet()
      if (res.success) {
        this.options = res.data
        this.recursion(this.options)
      }
    },
    recursion (arr) {
      // 删除children为空数组的属性值
      if (arr instanceof Array) {
        arr.forEach((item, index) => {
          if (item && item.children && item.children.length > 0) {
            this.recursion(item.children)
          } else {
            delete item.children
          }
        })
      }
    },
    handleClick (e) {
      // 详情点击事件
      this.$router.push({
        path: '/form-data/detail',
        query: {
          id: e._id,
          title: e.title
        }
      })
    },
    handleCurrentChange (e) {
      // 分页改变事件
      this.page = e
      this.getFormDataList()
    },
    search () {
      // 搜索
      this.page = 1
      this.getFormDataList()
    },
    reset () {
      // 重置
      this.tag = []
      this.state = 'all'
      this.titleVal = ''
      this.search()
    },
    handleArray (arr) {
      let newArr = []
      if (arr instanceof Array) {
        arr.forEach((item, index) => {
          newArr[index] = item[item.length - 1]
        })
      }
      return newArr
    }
  }
}
</script>
<style lang="scss" scoped>
.form-data {
  display: flex;
  flex-direction: column;
  width: calc(100% - 40px);
  height: 100%;
  margin: 0 auto;
  overflow: hidden;

  .header {
    padding-top: 10px;
    display: flex;
    justify-content: space-between;

    .search-list-item-title {
      line-height: 0 !important;

      /deep/ .el-input__inner {
        padding: 0 8px;
      }
    }

    .header-left {
      display: flex;
      flex-wrap: wrap;
    }

    .search-list {
      margin: 0 10px 10px 0;
      display: flex;
      // align-items: center;

      .search-list-item {
        margin-right: 10px;

        & /deep/ .el-input__inner {
          padding-right: 50px;
        }

        & /deep/ .el-input__suffix {
          .el-input__clear {
            position: absolute;
            top: 0;
            left: -25px;
          }
        }
      }
    }

    .btn-group {
      margin-bottom: 10px;
    }
  }

  .show-tips {
    margin-top: 6px;
    flex-shrink: 0;
    text-align: right;

    .tips {
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      height: 20px;

      span {
        font-size: 14px;
        cursor: pointer;
        color: #595959;
      }

      i {
        color: #888 !important;
        font-size: 20px;
        margin-right: 4px;
      }
    }
  }

  .pagination {
    margin-bottom: 20px;
  }

  & /deep/ .tag-item {
    height: 22px;
    line-height: 22px;
    padding: 0 8px;
    font-size: 12px;
    background-color: #ebeff4;
    color: #6b7b88;
  }

  .tag-group {
    .tag-item {
      margin-right: 8px;
    }
  }

  .h-title {
    .icon {
      font-size: 16px;
      color: #888;
      font-weight: normal;
      cursor: pointer;
    }
  }

  .h-t-popover {
    font-size: 14px;
    color: #262626;
    line-height: 24px;

    span {
      font-size: 14px;
      line-height: 24px;
      font-weight: 500 !important;
    }
  }

  .table {
    flex: 1;
    overflow: hidden;
  }
}
</style>
<style lang="scss">
.tag-popper {
  min-width: unset;
  padding: 10px 0 0 10px;

  .tag-item-wrapper {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 145px;
    max-height: 300px;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 5px;
      background-color: #fff;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: rgba(193, 193, 193, 0.8);
    }

    .tag-item {
      height: 22px;
      padding: 0 8px;
      margin-right: 10px;
      margin-bottom: 10px;
      line-height: 22px;
      background-color: #ebeff4;
      color: #6b7b88;
      border-radius: 2px;
      font-size: 12px;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
